module.exports = __webpack_public_path__ + "img/EXCEL.15984089.png";